export const fixationHTML =
  '<div class="effort-container"><div id="fixation-dot" class="color-white"> </div></div>';
